module.exports = "<div class=\"kl-mask {class}\" on-click={this._handleClick($event)}>\n  {#if content}{#inc @(content)}{/if}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/_deprecated_/KLMask/index.html
// module id = 388
// module chunks = 0